import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL + "/orders";

// const token = localStorage.getItem("token");
// const config = {
//   headers: {
//       Authorization: token,
//   },
// };
// axios.defaults.headers.common["Authorization"] = token;
// console.log('config',config)

const setTokenAllHeaders = async () => {
  const token = localStorage.getItem("adminToken");
  axios.defaults.headers.common["Authorization"] = token;
};

const getAllOrders = async ({
  limit = 10,
  page = 0,
  branchId = null,
  status = null,
  action = null,
  search = null,
  deliveryType = null,
  placedType = null,
  paymentTypes = undefined,
  fromDate = null,
  toDate = null,
  dateFilterField = null,
  needImage = true,
  needShippingAddress = true
}) => {
  try {
    await setTokenAllHeaders();
    let branch_id = branchId;
    if (parseInt(branch_id) === 0) {
      branch_id = null;
    }
    let sendStatus = status;
    if (sendStatus === 0) {
      sendStatus = null;
    }
    const response = await axios.get(`${BASE_URL}/getAll`, {
      params: {
        limit,
        page,
        branch_id,
        status: sendStatus,
        action,
        needImage,
        needShippingAddress,
        search,
        deliveryType,
        placedType,
        paymentTypes,
        fromDate,
        toDate,
        dateFilterField
      },
      withCredentials: true
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};

const getAllOrdersStatus = async () => {
  try {
    await setTokenAllHeaders();
    const response = await axios.get(`${BASE_URL}/getAllOrderStatus`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all orders:", error);
    throw error;
  }
};

const getOrderPrintList = async (params = null) => {
  try {
    await setTokenAllHeaders();
    let dt = { orderId: params.orderIds };
    const response = await axios.post(`${BASE_URL}/print`, dt);
    return response.data;
  } catch (error) {
    console.error(`Error fetching order id :`, error);
    throw error;
  }
};
const getOrderById = async (orderId) => {
  try {
    await setTokenAllHeaders();
    const response = await axios.get(`${BASE_URL}/details/${orderId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching order ${orderId}:`, error);
    throw error;
  }
};
const getOrderHistory = async (orderId) => {
  try {
    await setTokenAllHeaders();
    const response = await axios.get(`${BASE_URL}/history/${orderId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching order ${orderId}:`, error);
    throw error;
  }
};
const getCommonOrderById = async (orderId) => {
  try {
    await setTokenAllHeaders();
    const response = await axios.get(`${BASE_URL}/common/details/${orderId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching order ${orderId}:`, error);
    throw error;
  }
};

const getAllOrdersByStatus = async (status = 1, page = 0, limit = 10) => {
  try {
    await setTokenAllHeaders();
    const response = await axios.get(
      `${BASE_URL}/getAll/${status}?limit=${limit}&page=${page}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching orders:", error);
    throw error;
  }
};

const updateOrder = async (params) => {
  try {
    await setTokenAllHeaders();
    const dt = { ...params };
    const response = await axios.post(`${BASE_URL}/update`, dt);
    return response.data;
  } catch (error) {
    console.error(`Error updating Order:`, error);
    throw error;
  }
};
const createSaleOrder = async (params) => {
  try {
    await setTokenAllHeaders();
    const dt = { ...params };
    const response = await axios.post(`${BASE_URL}/createso`, dt);
    return response.data;
  } catch (error) {
    console.error(`Error updating Order:`, error);
    throw error;
  }
};
const updateDeliveredOrderConfirm = async (params) => {
  try {
    await setTokenAllHeaders();
    const dt = { ...params };
    const response = await axios.post(`${BASE_URL}/confirm/`, dt);
    return response.data;
  } catch (error) {
    console.error(`Error updating delivery confirmation:`, error);
    throw error;
  }
};

const transferOrder = async (params) => {
  try {
    await setTokenAllHeaders();
    const response = await axios.post(`${BASE_URL}/transfer`, params);
    return response.data;
  } catch (error) {
    console.error("Error transferring order:", error);
    throw error;
  }
};
const updateOrderStatus = async (params) => {
  try {
    await setTokenAllHeaders();
    const response = await axios.post(`${BASE_URL}/transfer/status`, params);
    return response.data;
  } catch (error) {
    console.error("Error transferring order:", error);
    throw error;
  }
};

const updateTakeawayOrder = async (params) => {
  try {
    await setTokenAllHeaders();
    const dt = { ...params };
    const response = await axios.post(`${BASE_URL}/takeaway/update`, dt);
    return response.data;
  } catch (error) {
    console.error(`Error updating Order:`, error);
    throw error;
  }
};

// export default {
//   getAllOrders,
//   getOrderById,
//   getAllOrdersStatus,
//   getAllOrdersByStatus
// };
const omsApi = {
  getAllOrders,
  getOrderById,
  getAllOrdersStatus,
  getAllOrdersByStatus,
  updateOrder,
  updateDeliveredOrderConfirm,
  getOrderPrintList,
  getCommonOrderById,
  transferOrder,
  updateOrderStatus,
  createSaleOrder,
  updateTakeawayOrder,
  getOrderHistory
};

// Export the named object
export default omsApi;

